

import Slider from './Slider'
import OurServices from './OurServices'
import AboutUs from './AboutUs';
import Carousel from './Carousel';
import ContactSection from './ContactSection';
function App() {
  return (
    <div className="App">
   
     <Slider/>
      
     <AboutUs/>
    <OurServices/>
    <Carousel/>
     <ContactSection/>
    </div>
  );
}

export default App;
